var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"filterable":false,"options":_vm.searchResults,"placeholder":_vm.__('planner.search_location'),"noDrop":_vm.searchResults.length == 0},on:{"search":(search, loading) => {
            _vm.searchAddress(search, loading)
        },"input":(option) => {
            _vm.optionSelectHandler(option)
        }},model:{value:(_vm.searchLocation),callback:function ($$v) {_vm.searchLocation=$$v},expression:"searchLocation"}},[_c('template',{slot:"no-options"},[_vm._v(" "+_vm._s(_vm.__('planner.search_location'))+" ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }